/* tslint:disable */
/* eslint-disable */

/**
 * Payment method enumeration - matches backend enum exactly
 */
export enum PaymentMethod {
  Credits = 0,
  SessionBundle = 1,
  Membership = 2,
  Stripe = 3,
  GoCardless = 4,
  Cash = 5,
  BankTransfer = 6,
  Card = 7
} 